import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, CopyButton, Tooltip } from '@mantine/core';
export type CopyWalletButtonProps = {
  value: string;
};
export const CopyWalletButton: React.FC<CopyWalletButtonProps> = ({
  value
}) => {
  const {
    i18n
  } = useLingui();
  return <Box style={{
    pointerEvents: 'auto',
    zIndex: 10
  }}>
      <CopyButton value={value} timeout={2000}>
        {({
        copied,
        copy
      }) => <Tooltip label={copied ? i18n._('Copied') : i18n._('Copy')} withArrow position="right">
            <ActionIcon color={copied ? 'var(--mantine-color-prime-0)' : 'var(--text-dark)'} variant="subtle" onClick={copy}>
              {copied ? <Icons className="icon-pr-line-copy" fontSize={24} /> : <Icons className="icon-pr-line-copy" fontSize={24} />}
            </ActionIcon>
          </Tooltip>}
      </CopyButton>
    </Box>;
};